
function check_card_type(e){
    var inp_value = '';
    const $logo_cont = am.$('.card-number');
    const $cvv = am.$('#cc_cvv2');
    const allowed_cards = ['visa', 'mastercard', 'discover', 'amex'];
    inp_value = am.$(e.target).val();
    var brand = cc_brand_id(inp_value);

    if(allowed_cards.includes(brand)){
        if($logo_cont.hasClass('visible') && $logo_cont.hasClass('visa mastercard discover amex') != brand){
            $logo_cont
                .removeClass('visible visa mastercard discover amex unknown')
                .children('.visible').removeClass('visible');
            $cvv.removeClass('visible visa mastercard discover amex unknown')
        }

        $logo_cont
            .addClass(brand + ' visible')
            .children('.'+brand).addClass('visible');
        $cvv.addClass(brand);
    }else if(brand == 'unknown' || !allowed_cards.includes(brand)){
        $logo_cont
            .removeClass('visible visa mastercard discover amex unknown')
            .children('.visible').removeClass('visible');
        $cvv.removeClass('visible visa mastercard discover amex unknown')
    }
}

function cc_brand_id(cur_val) {
    // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
    // regexp string length {0} provided for soonest detection of beginning of the card numbers this way it could be used for BIN CODE detection also

    //JCB
    jcb_regex = new RegExp('^(?:2131|1800|35)[0-9]{0,}$'); //2131, 1800, 35 (3528-3589)
    // American Express
    amex_regex = new RegExp('^3[47][0-9]{0,}$'); //34, 37
    // Diners Club
    diners_regex = new RegExp('^3(?:0[0-59]{1}|[689])[0-9]{0,}$'); //300-305, 309, 36, 38-39
    // Visa
    visa_regex = new RegExp('^4[0-9]{0,}$'); //4
    // MasterCard
    mastercard_regex = new RegExp('^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$'); //2221-2720, 51-55
    maestro_regex = new RegExp('^(5[06789]|6)[0-9]{0,}$'); //always growing in the range: 60-69, started with / not something else, but starting 5 must be encoded as mastercard anyway
    //Discover
    discover_regex = new RegExp('^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$');
    ////6011, 622126-622925, 644-649, 65

    // get rid of anything but numbers Note: Should already be filtering on input 
    cur_val = cur_val.replace(/\D/g, '');

    // checks per each, as their could be multiple hits
    //fix: ordering matter in detection, otherwise can give false results in rare cases
    var sel_brand = "unknown";
    if (cur_val.match(jcb_regex)) {
        sel_brand = "jcb";
    } else if (cur_val.match(amex_regex)) {
        sel_brand = "amex";
    } else if (cur_val.match(diners_regex)) {
        sel_brand = "diners_club";
    } else if (cur_val.match(visa_regex)) {
        sel_brand = "visa";
    } else if (cur_val.match(mastercard_regex)) {
        sel_brand = "mastercard";
    } else if (cur_val.match(discover_regex)) {
        sel_brand = "discover";
    } else if (cur_val.match(maestro_regex)) {
        if (cur_val[0] == '5') { //started 5 must be mastercard
            sel_brand = "mastercard";
        } else {
            sel_brand = "maestro"; //maestro is all 60-69 which is not something else, thats why this condition in the end
        }
    }

    return sel_brand;
}